module.exports = __webpack_public_path__ + "01_bob_black.4f62b028.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer5/01_bob_black.png
// module id = qst5
// module chunks = 0